import Swal from 'sweetalert2'

type CancelSlipResponse = {
  success: boolean
  message?: string
  data?: unknown
}

export async function showCancelSlipFeedback(response: CancelSlipResponse): Promise<boolean> {
  if (!response.success) {
    await Swal.fire({
      icon: 'error',
      title: 'คืนโพยไม่สำเร็จ',
      text: response.message || 'กรุณาลองใหม่อีกครั้ง',
      confirmButtonColor: '#3085d6',
    })
    return false
  }

  const payload = response.data as { refunded?: boolean; refundError?: string | null } | undefined
  if (payload?.refunded === false) {
    await Swal.fire({
      icon: 'warning',
      title: 'ยกเลิกโพยแล้ว แต่คืนเครดิตไม่สำเร็จ',
      text:
        payload.refundError ||
        'ระบบจะพยายามคืนเครดิตอัตโนมัติอีกครั้ง หากยอดไม่กลับภายในไม่กี่นาที กรุณาติดต่อแอดมิน',
      confirmButtonColor: '#3085d6',
    })
    return true
  }

  await Swal.fire({
    icon: 'success',
    title: 'คืนโพยสำเร็จ',
    text: response.message || 'ระบบคืนโพยเรียบร้อยแล้ว',
    confirmButtonColor: '#3085d6',
  })
  return true
}
